define("shared/modifiers/call-after-hover", ["exports", "@ember/object", "@glimmer/tracking", "ember-modifier"], function (_exports, _object, _tracking, _emberModifier) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"@ember/object",0,"@glimmer/tracking",0,"ember-modifier"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  /**
   *
   * @class CallAfterHoverModifier
   * @extends Modifier
   *
   * This modifier calls the given method after an element has
   * been hovered on for a minimum duration of time
   *
   * Positional Parameters:
   * @param {Method} methodToCall The method to execute after the hover event
   *
   * Named Parameters:
   * @param {Number} minimumHoverTimeInMs The minimum duration of the hover for the event to be called
   *
   * Examples:
   *
   * Simple Usage:
   *
   * ```
   * <div {{call-after-hover @actionInstance minimumHoverTimeInMs=1}}>
   * </div>
   *
   * Note: Automatically uses a default minimumHoverTimeInMs if the parameter is not passed.
   * Note: Does not throw error an error if methodToCall is not provided. Instead, modifier will not execute.
   * ```
   */
  let CallAfterHoverModifier = _exports.default = (_class = class CallAfterHoverModifier extends _emberModifier.default {
    constructor() {
      super(...arguments);
      _defineProperty(this, "DEFAULT_MINIMUM_HOVER_TIME_IN_MS", 5000);
      _initializerDefineProperty(this, "hoverStartTimeInMs", _descriptor, this);
    }
    get minimumHoverTimeInMs() {
      return this.args.named?.minimumHoverTimeInMs || this.DEFAULT_MINIMUM_HOVER_TIME_IN_MS;
    }
    get passedParams() {
      return this.args.positional.slice(1);
    }
    get methodToCall() {
      return this.args.positional[0];
    }
    handleMouseEnter() {
      this.hoverStartTimeInMs = Date.now();
    }
    handleMouseLeave() {
      if (this.hoverStartTimeInMs && Date.now() - this.hoverStartTimeInMs >= this.minimumHoverTimeInMs) {
        this.methodToCall(this.passedParams);
      } else {
        this.hoverStartTimeInMs = null;
      }
    }
    didReceiveArguments() {
      if (this.args.positional[0] && typeof this.args.positional[0] === 'function') {
        this.removeEventListener();
        this.addEventListener();
      }
    }
    willRemove() {
      this.removeEventListener();
    }
    addEventListener() {
      this.element.addEventListener('mouseenter', this.handleMouseEnter);
      this.element.addEventListener('mouseleave', this.handleMouseLeave);
    }
    removeEventListener() {
      this.element.removeEventListener('mouseenter', this.handleMouseEnter);
      this.element.removeEventListener('mouseleave', this.handleMouseLeave);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "hoverStartTimeInMs", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "handleMouseEnter", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleMouseEnter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleMouseLeave", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleMouseLeave"), _class.prototype)), _class);
});